/* global connect React Component */

export class ClientPage extends Component {
  render() {
    /* eslint-disable-next-line react/jsx-no-undef */
    return (<AppWrapper customTitle="Welcome Admin!" title="Dashboard">ClientPage</AppWrapper>)
  }
}

export default connect(ClientPage);